import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  withState,
  branch,
  renderComponent,
  renderNothing,
} from 'recompose';
import { getMembershipAgreement } from '../../membership/actions';
import Loader from '../../components/Loader';

export default compose(
  withRouter,
  withState('busy', 'setBusy', false),
  withState('agreement', 'setAgreement', null),
  lifecycle({
    async componentDidMount() {
      const membershipId = this.props.location.query.membership;
      this.props.setBusy(true);
      getMembershipAgreement(membershipId)
        .then(({ agreement }) => this.props.setAgreement(agreement))
        .finally(() => this.props.setBusy(false));
    },
  }),
  branch(
    props => props.busy,
    renderComponent(Loader),
  ),
  branch(
    props => !props.agreement,
    renderNothing,
  ),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withMembershipAgreement.js